import Setting from "views/Pages/Student/Setting/Setting.js";

let routes_student = [
  {
    path: "/user",
    name: "logo",
    icon: "now-ui-icons cs-menu",
    component: Setting,
    layout: "/student"
  },
  {
    path: "/setting",
    name: "Settings",
    icon: "now-ui-icons cs-setting",
    component: Setting,
    layout: "/student"
  }
];

export default routes_student;
